import { render, staticRenderFns } from "./webpush.vue?vue&type=template&id=494fb07c"
import script from "./webpush.vue?vue&type=script&lang=js"
export * from "./webpush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports